import { Box, Chip, Stack, Typography } from '@mui/material'

import { useTranslation } from 'react-i18next'

import { formatCutoffCountdown } from './cutoffCountdownDates'

interface OrderCutOffProps {
  orderTimeRemaining?: number | null
  showLabel: boolean
}

export function OrderCutOff({ orderTimeRemaining, showLabel }: OrderCutOffProps) {
  const { t } = useTranslation()
  const { label, isUrgent } = formatCutoffCountdown(orderTimeRemaining)
  const colour = isUrgent ? 'warning' : 'primary'

  const chipSx = {
    marginX: '1px',
    borderRadius: '4px',
    '& .MuiChip-label': {
      paddingX: 0.5,
    },
  }

  return (
    <Stack justifyContent="center" alignItems="center" height="100%">
      {showLabel && <Typography variant="caption">{t('cc:navBar.orderCutOff')}</Typography>}
      <Box
        sx={{
          display: 'flex',
          textWrap: 'noWrap',
          fontWeight: '500',
          alignItems: 'center',
          gap: '2px',
        }}>
        <Chip
          size="small"
          color={colour}
          sx={{ ...chipSx, '& .MuiChip-label': { paddingX: 1 } }}
          label={label}
        />
      </Box>
    </Stack>
  )
}
